import { ThemeProvider } from '@ori-ui/mui';
import { TestIdProvider } from '@ori/testid-generator';
import { type VFC, Suspense, useEffect, useState } from 'react';

import { Loading, ChatButton, ErrorBoundary } from './components';
import { ConfigurationProvider } from './contexts';
import { arabicStylesComplete, arabicStylesBack } from './styles/arabicStyles';
import type { AppConfiguration } from './types';

interface AppProps {
  configuration: AppConfiguration;
}

export const App: VFC<AppProps> = ({ configuration }) => {
  const { tenant, language } = configuration;
  const languageTenant = `${language}-${tenant.toLocaleUpperCase()}`;
  const [openedByDefault, setOpenedByDefault] = useState<boolean>(false);
  const [isIconVisible, setIsIconVisible] = useState<boolean>(false);

  useEffect(() => {
    const webMessengerRoot = document.getElementById('web-messenger-root');

    if (!webMessengerRoot) {
      setIsIconVisible(true);
    }

    if (languageTenant === 'ar-EG') {
      const style = document.createElement('style');
      style.innerHTML = arabicStylesComplete;
      document.head.append(style);
    }

    if (languageTenant === 'fr-MA' || languageTenant === 'en-EG') {
      const style = document.createElement('style');
      style.innerHTML = arabicStylesBack;

      document.head.append(style);
    }

    const urlSearchParams = new URLSearchParams(window.location.search);

    for (const param of urlSearchParams) {
      if (param[0] === 'openChat' && param[1] === 'true') {
        setOpenedByDefault(true);
      }
    }
  }, []);

  return isIconVisible ? (
    <ConfigurationProvider value={configuration}>
      <Suspense fallback={<Loading />}>
        <ErrorBoundary>
          <ThemeProvider
            enableCacheProvider
            cacheKey="online-genesys-widget"
          >
            <TestIdProvider
              team="Framework"
              project="genesys-widget"
            >
              <ChatButton
                {...configuration}
                isChatOpenedByDefault={openedByDefault}
              />
            </TestIdProvider>
          </ThemeProvider>
        </ErrorBoundary>
      </Suspense>
    </ConfigurationProvider>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment -- Need to return something
    <></>
  );
};
